import { useTracker } from '~/features/clickstream-sdk/composables/useTracker';
import { ETrackerActions } from '~/features/clickstream-sdk/ClickStreamTracker';
import type { IEventProperties } from '~/features/clickstream-sdk/models/eventProperties';

type TSuggestType = 'searchHistory' | 'suggest' | 'categorySuggest' | 'shopSuggest';

export function useSuggestTracker(suggestType: TSuggestType) {
  const { track } = useTracker({ block: suggestType, element: suggestType === 'searchHistory' ? 'item' : 'searchBox' });
  
  const trackView = (extraPayload: Partial<IEventProperties> = {}) => track({ action: ETrackerActions.VIEW, ...extraPayload });
  
  const trackClick = (extraPayload: Partial<IEventProperties> = {}) => track({ action: ETrackerActions.CLICK, ...extraPayload });
  
  return { trackView, trackClick };
}
